/**
 * Google Calendar links (D27). No Google API or credentials: a subscribe
 * link for the household's export feed, and an event-template link that
 * opens Google's "new event" screen pre-filled (lands immediately, unlike a
 * subscribed calendar which Google refreshes only every few hours).
 */
import { formatIcsUtc } from './ics-write.js';
const RENDER = 'https://calendar.google.com/calendar/render';
/** `https://host/x.ics` → `webcal://host/x.ics` (what calendar apps subscribe to). */
export function toWebcalUrl(url) {
    return url.replace(/^https?:\/\//i, 'webcal://');
}
/** "Add to Google Calendar" for a subscription feed. */
export function googleCalendarSubscribeUrl(feedUrl) {
    return `${RENDER}?cid=${encodeURIComponent(toWebcalUrl(feedUrl))}`;
}
/** "Add to Google Calendar" for one event (times in UTC; Google shows them locally). */
export function googleCalendarEventUrl(ev) {
    const params = [
        ['action', 'TEMPLATE'],
        ['text', ev.title],
        ['dates', `${formatIcsUtc(ev.start)}/${formatIcsUtc(ev.end)}`],
    ];
    if (ev.details)
        params.push(['details', ev.details]);
    if (ev.location)
        params.push(['location', ev.location]);
    return `${RENDER}?${params.map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')}`;
}
//# sourceMappingURL=google.js.map